import { type Common } from './common.js';
import {
  type NoticeOfAdmission,
  type NoticeOfAdmissionStatus,
  type UpsertStatus,
} from './models/noticeOfAdmission.js';

export class API {
  common: Common;
  readonly baseEndpoint = '/notice-of-admission';

  constructor(common: Common) {
    this.common = common;
  }

  async findOne(encounterId: string): Promise<NoticeOfAdmission> {
    const url = this.common.constructPath(this.baseEndpoint, {
      encounterId,
    });
    return await this.common.getJSON(url);
  }

  async upsert(encounterId: string, context: NoticeOfAdmission): Promise<NoticeOfAdmission> {
    const url = this.common.constructPath(this.baseEndpoint);
    return await this.common.putJSON(url, { encounterId, context });
  }

  async getStatus(encounterId: string): Promise<NoticeOfAdmissionStatus | null> {
    const url = this.common.constructPath(`${this.baseEndpoint}/status`, {
      encounterId,
    });
    return (await this.common.getJSON(url)) ?? null;
  }

  async upsertStatus(args: UpsertStatus): Promise<NoticeOfAdmissionStatus | undefined> {
    const url = this.common.constructPath(`${this.baseEndpoint}/status`);
    return await this.common.putJSON(url, args);
  }

  async startExport(encounterId: string): Promise<{ success: true }> {
    const url = this.common.constructPath(`${this.baseEndpoint}/export`);
    return await this.common.postJSON(url, {
      encounterId,
      workflowHandling: 'REQUIRE',
    });
  }

  async startExtract(encounterId: string): Promise<{ success: true }> {
    const url = this.common.constructPath(`${this.baseEndpoint}/extract`);
    return await this.common.postJSON(url, {
      encounterId,
      workflowHandling: 'REQUIRE',
    });
  }
}
